export default __webpack_public_path__ + "scenes20a5730.png";